import { getApiCurrentLanguage, getDoceCasosSections } from "./functions";
import axios from "axios";

export const domain = "https://dedalo.oroibidea.es";
const URL_SERVER = domain + "/dedalo/lib/dedalo/publication/server_api/v1/json";
// const db_name = "web_oroibidea_pre";
// const code = "inm3014rtAw_testimonios_PRE";

const db_name = 'dedalo4_public';
const code = 'inm3014rtAw_testimonios';

const records = "/records";
const fragmentFromIndex = "/fragment_from_index_locator";
const language = getApiCurrentLanguage();
const tableCenso = "repressed_teachers_census";
const tableTsCensus = "ts_teachers_census";


export async function getMenu() {
    try {
        const response = await axios.post(
            URL_SERVER +
            records +
            "?code=" +
            code +
            "&db_name=" +
            db_name +
            "&table=" +
            tableTsCensus +
            "&lang=lg-" +
            language +
            "&sql_filter=parents='[\"navarra366_183\"]'" +
            "&order=norder asc"
        );

        return response.data.result
            ? response.data.result
            : null;

    } catch (error) {
        console.error("Error fetching menu data:", error);
        return null;
    }
}


export async function getMaestros(letter = "A", keyword = "") {
    try {
        const sqlFilter = keyword
            ? `ref_victim_surname LIKE '%${keyword}%' OR ref_victim_name LIKE '%${keyword}%'`
            : `ref_victim_surname LIKE '${letter}%'`;

        const response = await axios.post(
            URL_SERVER +
            records +
            "?code=" +
            code +
            "&db_name=" +
            db_name +
            "&table=" +
            tableCenso +
            "&lang=lg-" +
            language +
            "&sql_filter=" + encodeURIComponent(sqlFilter)
        );

        return response.data.result
            ? response.data.result.sort((a, b) => a.ref_victim_surname.localeCompare(b.ref_victim_surname))
            : null;

    } catch (error) {
        console.error("Error fetching data:", error);
        return null;
    }
}


export async function getGlosario(letterRange = "A-F", parent = null) {
    try {

        const ranges = {
          "A-F": `(term LIKE 'A%' OR term LIKE 'B%' OR term LIKE 'C%' OR term LIKE 'D%' OR term LIKE 'E%' OR term LIKE 'F%')`,
          "G-L": `(term LIKE 'G%' OR term LIKE 'H%' OR term LIKE 'I%' OR term LIKE 'J%' OR term LIKE 'K%' OR term LIKE 'L%')`,
          "M-S": `(term LIKE 'M%' OR term LIKE 'N%' OR term LIKE 'O%' OR term LIKE 'P%' OR term LIKE 'Q%' OR term LIKE 'R%' OR term LIKE 'S%')`,
          "T-Z": `(term LIKE 'T%' OR term LIKE 'U%' OR term LIKE 'V%' OR term LIKE 'W%' OR term LIKE 'X%' OR term LIKE 'Y%' OR term LIKE 'Z%')`,
        }

        const range = ranges[letterRange] || ranges["A-F"];

        const sqlFilter = parent
            ? `parents='[\"${parent.term_id}\"]' AND ${range}`
            : range;

        return axios.post(
            URL_SERVER +
            records +
            "?code=" +
            code +
            "&db_name=" +
            db_name +
            "&table=" +
            tableTsCensus +
            "&lang=lg-" +
            language +
            "&sql_filter=" + encodeURIComponent(sqlFilter)
        )
            .then((response) => {
                return response.data.result
                    ? response.data.result.sort((a, b) => a.term.localeCompare(b.term))
                    : null;
            });

    } catch (error) {
        console.error("Error fetching data:", error);
        return null;
    }
}


export async function getItemsTeasaureByParent(parent = null, parentCategory = null, order = null) {
    try {

        const sqlFilter = parentCategory
            ? `parents LIKE '%${parentCategory.term_id}%'`
            : parent
                ? `parents='[\"${parent.term_id}\"]'`
                : ``;


        return axios.post(
            URL_SERVER +
            records +
            "?code=" +
            code +
            "&db_name=" +
            db_name +
            "&table=" +
            tableTsCensus +
            "&lang=lg-" +
            language +
            "&sql_filter=" + encodeURIComponent(sqlFilter)
        )
            .then((response) => {
                if (order === true) {
                    return response.data.result
                        ? response.data.result.sort((a, b) => a.section_id - b.section_id)
                        : null;
                }
                return response.data.result
                    ? response.data.result
                    : null;

            });

    } catch (error) {
        console.error("Error fetching data:", error);
        return null;
    }
}




export async function getLineaTiempo(parent = null, parentCategory = null) {
    try {

        const sqlFilter = parentCategory
            ? `parents LIKE '%${parentCategory.term_id}%'`
            : parent
                ? `parents='[\"${parent.term_id}\"]'`
                : ``;


        return axios.post(
            URL_SERVER +
            records +
            "?code=" +
            code +
            "&db_name=" +
            db_name +
            "&table=" +
            tableTsCensus +
            "&lang=lg-" +
            language +
            "&sql_filter=" + encodeURIComponent(sqlFilter)
        )
            .then((response) => {
                return response.data.result
                    ? response.data.result.sort((a, b) => a.date_in - b.date_in)
                    : null;

            });



    } catch (error) {
        console.error("Error fetching data:", error);
        return null;
    }
}

export async function getItemMenu(section_id) {

    return await axios
        .post(
            URL_SERVER +
            records +
            "?code=" +
            code +
            "&db_name=" +
            db_name +
            "&table=" +
            tableTsCensus +
            "&lang=lg-" +
            language +
            "&section_id=" +
            section_id
        )
        .then((res) => {

            const item = res.data.result[0] ? res.data.result[0] : null;

            return item;

        });

}


export async function getDoceCasos() {

    var params = new URLSearchParams({
        resolve_portal: false,
        resolve_portals_custom: '{"image":"image"}',
        resolve_dd_relations: false,
    }).toString();

    var parent = "navarra366_6";

    const doceCasosSections = getDoceCasosSections();
    const validSections = doceCasosSections.map(section => section.sectionTs);

    return await axios
        .post(
            URL_SERVER +
            records +
            "?code=" +
            code +
            "&db_name=" +
            db_name +
            "&table=" +
            tableTsCensus +
            "&lang=lg-" +
            language +
            "&" +
            params +
            "&sql_filter=parents='[\"" +
            parent +
            "\"]'"
        )
        .then((res) => {
            const filteredResults = res.data.result.filter(item =>
                validSections.includes(item.section_id)
            );

            console.log(filteredResults);
            return filteredResults.length > 0 ? filteredResults : null;
        });
}

export async function getOtrosFuncionarios(parentTerm) {

    const sqlFilter = parentTerm
        ? `parents LIKE '%${parentTerm.term_id}%'` : '';

    var params = new URLSearchParams({
        resolve_portal: false,
        resolve_portals_custom: '{"image":"image"}',
        resolve_dd_relations: false,
    }).toString();

    var parent = parentTerm.term_id;

    return await axios
        .post(
            URL_SERVER +
            records +
            "?code=" +
            code +
            "&db_name=" +
            db_name +
            "&table=" +
            tableTsCensus +
            "&lang=lg-" +
            language +
            "&" +
            params +
            "&sql_filter=" + encodeURIComponent(sqlFilter)

        )
        .then((res) => {
            return res.data.result ? res.data.result : null;
        });
}


export async function getCaso(section_id) {

    var params = new URLSearchParams({
        resolve_portal: false,
        resolve_portals_custom: '{"image":"image", "other_images":"image"}',
        resolve_dd_relations: false,
    }).toString();

    return await axios
        .post(
            URL_SERVER +
            records +
            "?code=" +
            code +
            "&db_name=" +
            db_name +
            "&table=" +
            tableTsCensus +
            "&lang=lg-" +
            language +
            "&" +
            params +
            "&section_id=" +
            section_id
        )
        .then((res) => {

            const caso = res.data.result[0] ? res.data.result[0] : null;

            if (caso === null) return null;

            console.log(language);
            if (caso.uri) {
                try {
                    const fichasJSON = JSON.parse(caso.uri);
                    caso.fichaOroibidea = null;
                    caso.fichaUPNA = null;
                    caso.linkBiografia = null;

                    fichasJSON.forEach((ficha) => {

                        if (ficha.title.includes("Oroibidea") && ficha.iri) {
                            caso.fichaOroibidea = ficha.iri;
                        }

                        if (ficha.title.includes("Biograf") && ficha.iri) {
                            caso.linkBiografia = ficha.iri;
                        }

                        if (language === "eus") {
                            if (ficha.title.includes("NUP") && ficha.iri) {
                                caso.fichaUPNA = ficha.iri;
                            }
                        } else {
                            if (ficha.title.includes("UPNA") && ficha.iri) {
                                caso.fichaUPNA = ficha.iri;
                            }
                        }
                    });

                } catch (error) {
                    caso.uri = null;
                }
            } else {
                caso.uri = null;
            }

            return caso;

        });
}



export async function getMaestro(section_id) {


    var params = new URLSearchParams({
        resolve_portal: false,
        resolve_portals_custom:
            '{"victim":"informant", "victim.biography_data":"informant_biography", ' +
            '"event_data":"repressed_teachers_census_events",' +
            '"bibliographic_references_data": "bibliographic_references"}',
        resolve_dd_relations: false,
    }).toString();

    return await axios
        .post(
            URL_SERVER +
            records +
            "?code=" +
            code +
            "&db_name=" +
            db_name +
            "&table=" +
            tableCenso +
            "&lang=lg-" +
            language +
            "&" +
            params +
            "&section_id=" +
            section_id
        )
        .then((res) => {

            const maestro = res.data.result[0] ? res.data.result[0] : null;

            return maestro;

        });
}

export async function getRespondeHistoriadora(parent = null, parentCategory = null, order = null) {
    try {
        const sqlFilter = parentCategory
            ? `parents LIKE '%${parentCategory.term_id}%'`
            : parent
                ? `parents='[\"${parent.term_id}\"]'`
                : ``;

        const response = await axios.post(
            URL_SERVER +
            records +
            "?code=" +
            code +
            "&db_name=" +
            db_name +
            "&table=" +
            tableTsCensus +
            "&lang=lg-" +
            language +
            "&sql_filter=" + encodeURIComponent(sqlFilter)
        );

        if (response.data.result) {
            // Usamos map para crear una lista de promesas y luego `await` para procesarlas todas
            const results = await Promise.all(response.data.result.map(async (item) => {
                if (item.indexations) {
                    const indexationsArray = JSON.parse(item.indexations);

                    try {
                        // Obtener fragmento y esperar a que la promesa se resuelva
                        const fragmentResponse = await getFragment(indexationsArray[0]);
                        const fragmentData = fragmentResponse?.result;

                        if (fragmentData) {
                            item.fragmentData = fragmentData; // Guarda los datos en el objeto `item`
                        }
                    } catch (error) {
                        console.error("Error fetching fragment:", error);
                    }
                }
                return item;
            }));

            // Retornar la lista de resultados ordenados
            return results.sort((a, b) => a.norder - b.norder);
        }

        return null;
    } catch (error) {
        console.error("Error fetching data:", error);
        return null;
    }
}


async function getFragment(index_locator) {
    const transformedObject = {
        section_tipo: index_locator.section_tipo,
        section_id: index_locator.section_id,
        tag_id: index_locator.tag_id
    };

    const resultString = JSON.stringify(transformedObject);
    try {
        const response = await axios.post(
            URL_SERVER +
            fragmentFromIndex +
            "?code=" +
            code +
            "&db_name=" +
            db_name +
            "&lang=lg-" +
            language +
            "&index_locator=" +
            resultString
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching fragment:", error);
        return null;
    }
}


export async function getMapCoordinates(birthplace = true) {
    var params = new URLSearchParams({
        resolve_portal: false,
        resolve_portals_custom: '{"victim":"informant", "victim.biography_data":"informant_biography"}',
        resolve_dd_relations: false,
    }).toString();

    return await axios
        .post(
            URL_SERVER +
            records +
            "?code=" +
            code +
            "&db_name=" +
            db_name +
            "&table=" +
            tableCenso +
            "&lang=lg-" +
            language +
            "&" +
            params
        )
        .then((res) => {

            const maestros = res.data.result ? res.data.result : null;
            const coordinatesMap = {};

            if (maestros) {
                maestros.forEach((maestro) => {
                    let parsedGeoJSON = null; // Asegurarse de definir la variable aquí

                    if (birthplace) {
                        if (maestro.victim && maestro.victim[0] && maestro.victim[0].birthplace_geojson) {
                            parsedGeoJSON = maestro.victim[0].birthplace_geojson;
                        }
                    } else {
                        if (maestro.victim && maestro.victim[0] && maestro.victim[0].biography_data[0] && maestro.victim[0].biography_data[0].location_geojson) {
                            parsedGeoJSON = maestro.victim[0].biography_data[0].location_geojson;
                        }
                    }

                    // Si parsedGeoJSON es una cadena, convertirla a un objeto JSON
                    if (typeof parsedGeoJSON === 'string') {
                        parsedGeoJSON = JSON.parse(parsedGeoJSON);
                    }

                    // Asegurarse de que parsedGeoJSON contiene las coordenadas
                    if (Array.isArray(parsedGeoJSON) && parsedGeoJSON[0] && parsedGeoJSON[0].layer_data) {
                        const layerData = parsedGeoJSON[0].layer_data;

                        if (layerData.features && layerData.features.length > 0) {
                            const coordinates = layerData.features[0].geometry.coordinates;

                            const coordinatesKey = coordinates.join(",");

                            if (coordinatesMap[coordinatesKey]) {
                                coordinatesMap[coordinatesKey].push(maestro);
                            } else {
                                coordinatesMap[coordinatesKey] = [maestro];
                            }
                        }
                    }
                });
            }


            const result = Object.keys(coordinatesMap).map((key) => {
                const [longitude, latitude] = key.split(",").map(Number);
                return {
                    coordinates: [longitude, latitude],
                    maestros: coordinatesMap[key]
                };
            });

            return result;

        })
        .catch((error) => {
            console.error("Error al obtener las coordenadas:", error);
            return [];
        });
}
